import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { RoleRouter } from './components';
import DefaultLayout from './components/base/layout/DefaultLayout';
import FullWidthLayout from './components/base/layout/FullWidthLayout';
import { RelatorioContent } from './module/admin/pages/RelatorioContent';
import { AnunciosPage } from './module/company/pages/AnunciosPage';
import { NewAdPackage } from './module/company/pages/NewAdPackagePage';
import { CreateOrUpdateAdsTab } from './module/company/pages/NewAdsTab';
import { CreateOrUpdateVehicleTab } from './module/company/pages/NewVeichleForAdsComboTab';
import { AnuncioComboDetails } from './module/shopkeeper/pages/AnuncioComboDetails';
import { AnuncioDetails } from './module/shopkeeper/pages/AnuncioDetails';
import { AnunciosPages } from './module/shopkeeper/pages/AnunciosPage';
import { PerfilBase } from './module/shopkeeper/pages/PerfilBase';
import {
  AdminDashboard,
  AdminDealerReport,
  AdminLookerAnuncios,
  AdminLookerCanalAvaliador,
  AdminLookerConcessionarias,
  AdminLookerLojistas,
  AdminLookerPagamentos,
  AdminLookerUsuarios,
  AdminLookerVendas,
  AdminOfferReport,
  AdminPaymentsDefaultersReport,
  AdminPaymentsReport,
  AdminSellerReport,
  AdminShopkeeperDelayPayments,
  AdminShopkeeperReport,
  AdminShopkeeperWithoutPurchase,
  ChangePassword,
  ConcessionariaRevenda,
  DealerDefaultText,
  Indicacao,
  MyAccount,
  MyDataAdmin,
  MyDataDealer,
  MyDataShopkeeper,
  NewAccessory,
  NewBrand,
  NewDealership,
  NewGroup,
  NewModel,
  NewShopkeeper,
  NewUser,
  NewYear,
  Payments,
  PushEmailCustom,
  Registration,
  RegistrationAccessories,
  RegistrationBrands,
  RegistrationDealerships,
  RegistrationGroups,
  RegistrationModels,
  RegistrationResume,
  RegistrationShopkeepers,
  RegistrationUsers,
  RegistrationYears,
  Reports,
  SellerReport,
  Settings,
  Support
} from './pages';
import PageViewScreen from './pages/story-offer/StoryOffer';
import { useUserStore } from './stores';
import { UserRole } from './utils';
import { RotaProtegida } from './utils/hooks/useAuthRouterPages';


const HomePage: FC = () => {
  const { user } = useUserStore();
  const role = user?.grupoAcesso.id.toString();

  if (role === UserRole.Shopkeeper) {
    return (
      <DefaultLayout>
        <AnunciosPages showDashboard={true} />
      </DefaultLayout>
    );
  }

  return (
    <FullWidthLayout>
      <RelatorioContent />
    </FullWidthLayout>
  );
};

// [REFACTOR] usePushEmail removido daqui — movido para PushEmailCustom (evita chamada de API no carregamento global)
const Router: FC = () => {
  return (
    <Routes>
      {/* ================= HOME ================= */}
      <Route path="/" element={<HomePage />} />

      {/* ================= ANÚNCIOS ================= */}
      <Route
        path="/anuncios"
        element={
          <FullWidthLayout>
            <RoleRouter
              dealerComponent={<AnunciosPage />}
              shopkeeperComponent={<AnunciosPages showDashboard={false} />}
              adminComponent={<AnunciosPage />}
            />
          </FullWidthLayout>
        }
      />

      <Route
        path="/anuncios/detalhe/:id"
        element={
          <DefaultLayout>
            <AnuncioDetails />
          </DefaultLayout>
        }
      />
      <Route
        path="/anuncios/detalhe/combo/:id"
        element={
          <DefaultLayout>
            <AnuncioComboDetails />
          </DefaultLayout>
        }
      />

      <Route
        path="/anuncios/novo/:adId?"
        element={
          <DefaultLayout>
            <CreateOrUpdateAdsTab />
          </DefaultLayout>
        }
      />

      <Route
        path="/anuncios/novo/combo/:adId?"
        element={
          <DefaultLayout>
            <NewAdPackage />
          </DefaultLayout>
        }
      />
      <Route
        path="/veiculo/novo/:adId?"
        element={
          <DefaultLayout>
            <CreateOrUpdateVehicleTab />
          </DefaultLayout>
        }
      />

      {/* ================= MINHAS COMPRAS ================= */}
      <Route
        path="/minhas-compras"
        element={
          <FullWidthLayout>
            <PerfilBase />
          </FullWidthLayout>
        }
      />

      <Route
        path="/anuncio/historico/:id"
        element={
          <DefaultLayout>
            <PageViewScreen />
          </DefaultLayout>
        }
      />

      {/* ================= MINHA CONTA ================= */}
      <Route
        path="/minha-conta"
        element={
          <DefaultLayout>
            <MyAccount>
              <RoleRouter
                dealerComponent={<DealerDefaultText />}
                adminComponent={<MyDataAdmin />}
              />
            </MyAccount>
          </DefaultLayout>
        }
      />
      <Route
        path="/minha-conta/lojista"
        element={
          <FullWidthLayout>
              <PerfilBase/>
          </FullWidthLayout>
        }
      />

      <Route
        path="/minha-conta/meus-dados"
        element={
          <DefaultLayout>
            <MyAccount>
              <RoleRouter
                dealerComponent={<MyDataDealer />}
                shopkeeperComponent={<MyDataShopkeeper />}
              />
            </MyAccount>
          </DefaultLayout>
        }
      />

      <Route
        path="/minha-conta/configuracoes"
        element={
          <DefaultLayout>
            <MyAccount>
              <Settings />
            </MyAccount>
          </DefaultLayout>
        }
      />

      <Route
        path="/minha-conta/alterar-senha"
        element={
          <DefaultLayout>
            <MyAccount>
              <ChangePassword />
            </MyAccount>
          </DefaultLayout>
        }
      />

      <Route
        path="/minha-conta/suporte"
        element={
          <DefaultLayout>
            <MyAccount>
              <Support />
            </MyAccount>
          </DefaultLayout>
        }
      />

      {/* ================= RELATÓRIOS ================= */}
      <Route
			path='/relatorios/admin-dashboard'
			element={
        <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminDashboard />} />
          </Reports>
        </DefaultLayout>
			}
		/>
		<Route
			path='/relatorios/admin-anuncios'
			element={
        <DefaultLayout>
            <Reports>
              <RoleRouter adminComponent={<AdminLookerAnuncios />} />
          </Reports>
        </DefaultLayout>

			}
		/>
		<Route
			path='/relatorios/admin-vendas'
			element={
        <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminLookerVendas />} />
          </Reports> 
        </DefaultLayout>
 
			}
		/>
      <Route
        path='/relatorios/admin-vendas-interno'
        element={
          <DefaultLayout>
            <Reports>
              <RoleRouter adminComponent={<AdminSellerReport />} />
            </Reports>
          </DefaultLayout>
        }
      />
      <Route
        path='/relatorios/admin-anuncios-interno'
        element={
          <DefaultLayout>
            <Reports>
              <RoleRouter adminComponent={<AdminOfferReport />} />
            </Reports>
          </DefaultLayout>
        }
      />
      <Route
        path='/relatorios/admin-pagamentos-interno'
        element={
          <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminPaymentsReport />} />
          </Reports>
          </DefaultLayout>
        }
      />
      <Route
        path='/relatorios/admin-revendas-sem-compras'
        element={
          <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminShopkeeperWithoutPurchase />} />
          </Reports>
          </DefaultLayout>
        }
      />
      <Route
        path='/relatorios/admin-pagamentos-inadimplentes'
        element={
          <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminPaymentsDefaultersReport />} />
          </Reports>
          </DefaultLayout>
        }
      />
      <Route
        path='/relatorios/admin-compradores-atrasam-pagamentos'
        element={
          <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminShopkeeperDelayPayments />} />
          </Reports>
          </DefaultLayout>
        }
      />
      <Route
        path='/relatorios/admin-concessionarias-interno'
        element={
          <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminDealerReport />} />
          </Reports>
          </DefaultLayout>
        }
      />
      <Route
        path='/relatorios/admin-lojistas-interno'
        element={
          <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminShopkeeperReport />} />
          </Reports>
          </DefaultLayout>
        }
      />
      <Route
        path='/relatorios/admin-concessionarias'
        element={
          <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminLookerConcessionarias />} />
          </Reports>
          </DefaultLayout>
        }
      />
      <Route
        path='/relatorios/admin-lojistas'
        element={
          <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminLookerLojistas />} />
          </Reports>
          </DefaultLayout>
        }
      />
      <Route
        path='/relatorios/admin-usuarios'
        element={
          <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminLookerUsuarios />} />
          </Reports>
          </DefaultLayout>
        }
      />
      <Route
        path='/relatorios/admin-canal-avaliador'
        element={
          <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminLookerCanalAvaliador />} />
          </Reports>
          </DefaultLayout> 
        }
      />
      <Route
        path='/relatorios/admin-pagamentos'
        element={
          <DefaultLayout>
          <Reports>
            <RoleRouter adminComponent={<AdminLookerPagamentos />} />
          </Reports>
          </DefaultLayout>
        }
      />
       <Route path="/relatorios" element={<HomePage />} />
      <Route
        path='/relatorios/vendas-concessionaria'
        element={
          <DefaultLayout>
          <Reports>
            <RoleRouter dealerComponent={<SellerReport />} adminComponent={<AdminSellerReport />} />
          </Reports>
          </DefaultLayout>
        }
      />

      <Route
        path="/relatorios/admin-anuncios"
        element={
          <DefaultLayout>
            <Reports>
              <RoleRouter adminComponent={<AdminLookerAnuncios />} />
            </Reports>
          </DefaultLayout>
        }
      />
    <Route path='/financeiro' element={ 
      <RotaProtegida  perfisPermitidos={['1']}> 
      <FullWidthLayout>
        <Payments />
      </FullWidthLayout>
      </RotaProtegida>} />
    <Route path='/indicacao' element={
      <RotaProtegida perfisPermitidos={['1', '2', '3']}>
        <FullWidthLayout>
          <Indicacao />
        </FullWidthLayout>
      </RotaProtegida>
    } />
      <Route
        path="/relatorios/admin-vendas"
        element={
          <DefaultLayout>
            <Reports>
              <RoleRouter adminComponent={<AdminLookerVendas />} />
            </Reports>
          </DefaultLayout>
        }
      />

      {/* ================= CADASTROS ================= */}
      <Route
			path='/cadastros'
			element={
        <DefaultLayout>
				<RotaProtegida  perfisPermitidos={['1', '2']}>
				<Registration>
					<RegistrationResume  />
				</Registration>
				</RotaProtegida>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/grupo-concessionarias'
			element={
        <DefaultLayout>
				<Registration>
					<RegistrationGroups />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/grupo-concessionarias/novo'
			element={
        <DefaultLayout>
				<Registration>
					<NewGroup />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/grupo-concessionarias/editar/:id'
			element={
				<Registration>
					<NewGroup />
				</Registration>
			}
		/>
		<Route
			path='/cadastros/concessionarias'
			element={
        <DefaultLayout>
				<Registration>
					<RegistrationDealerships />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/concessionarias/novo'
			element={
        <DefaultLayout>
          <Registration>
            <NewDealership />
          </Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/concessionarias/editar/:id'
			element={
        <DefaultLayout>
				<Registration>
					<NewDealership />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/lojistas'
			element={
        <DefaultLayout>
				<Registration>
					<RegistrationShopkeepers />
				</Registration>
        </DefaultLayout> 
			}
		/>
		<Route
			path='/cadastros/lojistas/novo'
			element={
        <DefaultLayout>
				<Registration>
					<NewShopkeeper />
				</Registration>
        </DefaultLayout> 
			}
		/>
		<Route
			path='/cadastros/lojistas/editar/:id'
			element={
        <DefaultLayout>
				<Registration>
					<NewShopkeeper />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/concessionaria-revenda'
			element={
				<DefaultLayout>
					<RotaProtegida perfisPermitidos={['1']}>
						<Registration>
							<ConcessionariaRevenda />
						</Registration>
					</RotaProtegida>
				</DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/texto-padrao'
			element={
        <DefaultLayout>  
				<Registration>
					<DealerDefaultText />
				</Registration>
        </DefaultLayout>  
			}
		/>
		<Route
			path='/cadastros/usuarios'
			element={
        <DefaultLayout> 
				<Registration>
					<RegistrationUsers />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/usuarios/novo'
			element={
        <DefaultLayout> 
				<Registration>
					<NewUser />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/usuarios/editar/:id'
			element={
        <DefaultLayout> 
				<Registration>
					<NewUser />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/usuarios/:filters?'
			element={
        <DefaultLayout> 
				<Registration>
					<RegistrationUsers />
				</Registration>
        </DefaultLayout> 
			}
		/>

		<Route
			path='/cadastros/veiculos-marcas'
			element={
        <DefaultLayout> 
				<Registration>
					<RegistrationBrands />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/veiculos-marcas/novo'
			element={
        <DefaultLayout>
				<Registration>
					<NewBrand />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/veiculos-modelos'
			element={
        <DefaultLayout> 
				<Registration>
					<RegistrationModels />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/veiculos-modelos/novo'
			element={
        <DefaultLayout>
				<Registration>
					<NewModel />
				</Registration>
        </DefaultLayout>        
			}
		/>
		<Route
			path='/cadastros/veiculos-anos'
			element={
        <DefaultLayout>
				<Registration>
					<RegistrationYears />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/veiculos-anos/novo'
			element={
				<DefaultLayout>
        <Registration>
					<NewYear />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/veiculos-acessorios'
			element={
        <DefaultLayout>
				<Registration>
					<RegistrationAccessories />
				</Registration>
        </DefaultLayout>
			}
		/>
		<Route
			path='/cadastros/veiculos-acessorios/novo'
			element={
<DefaultLayout>
				<Registration>
					<NewAccessory />
				</Registration>
        </DefaultLayout>
			}
		/>
		{/* [REFACTOR] props removidas — PushEmailCustom agora usa usePushEmail internamente */}
		<Route
			path='/cadastros/envio-push-email'
			element={
				<Registration>
					<PushEmailCustom />
				</Registration>
      } />

      {/* ================= RELATÓRIOS V2 ================= */}
      <Route path="/admin/relatorios" element={<Navigate to="/" />} />

      {/* ================= FALLBACK ================= */}
      <Route
        path="*"
        element={
          <DefaultLayout>
            <Navigate to="/" />
          </DefaultLayout>
        }
      />
    </Routes>
  );
};

export default Router;
